// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__alvHL","title":"AfterFrontImage_title__3PkoS"};